export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10294.d6b1009b.jpg";